import setupDeprecationWorkflow from 'ember-cli-deprecation-workflow';

/**
 * Docs: https://github.com/ember-cli/ember-cli-deprecation-workflow
 */
setupDeprecationWorkflow({
  /**
    false by default, but if a developer / team wants to be more aggressive about being proactive with
    handling their deprecations, this should be set to "true"
  */
  throwOnUnhandled: false,
  workflow: [
    {
      handler: 'silence',
      matchId: 'ember-data:deprecate-promise-many-array-behaviors',
    },
    { handler: 'silence', matchId: 'ember-data:deprecate-array-like' },
    { handler: 'silence', matchId: 'ember-string.add-package' },
    {
      handler: 'silence',
      matchId: 'ember-concurrency.deprecate-classic-task-api',
    },
    {
      handler: 'silence',
      matchId: 'importing-inject-from-ember-service',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-change-properties-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-libraries-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-view-utils-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import--set-classic-decorator-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-test-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-meta-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-testing-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'deprecate-import-can-invoke-from-ember',
    },
    {
      handler: 'silence',
      matchId: 'ember-basic-dropdown.config-environment',
    },
  ],
});
